import { CSSProperties } from 'react';

import {
  CustomTypographyVariants,
  getTextStyles,
  speakersPalette,
  squareBlockCSS,
  styledOmitCustomProps,
} from '@braskai/ui-kit';

import { css, styled } from '@mui/material';

import { Avatar } from '@/shared/ui/Avatar';

import { TeamspaceAvatarProps } from './types';

type SAvatarProps = {
  $color?: TeamspaceAvatarProps['color'];
  $disabled?: TeamspaceAvatarProps['disabled'];
  $isActive?: TeamspaceAvatarProps['isActive'];
  $size?: TeamspaceAvatarProps['size'];
};

type SizeOutputProps = {
  borderRadius?: CSSProperties['borderRadius'];
  fontVariant: keyof CustomTypographyVariants;
  size: number;
};

const getSize = (size: TeamspaceAvatarProps['size'] = 'md'): SizeOutputProps => {
  const sizes: Record<string, SizeOutputProps> = {
    lg: {
      borderRadius: '10px',
      fontVariant: 'title-4-md',
      size: 40,
    },
    md: {
      borderRadius: '8px',
      fontVariant: 'title-4-md',
      size: 32,
    },
    sm: {
      borderRadius: '6px',
      fontVariant: 'caption-1-md',
      size: 24,
    },
  };

  return sizes[size];
};

export const SAvatar = styled(
  Avatar,
  styledOmitCustomProps,
)<SAvatarProps>(({ $color = 'midnight', $isActive = false, $size = 'md', $disabled = false, theme }) => {
  const { borderRadius, fontVariant, size } = getSize($size);

  return css`
    ${squareBlockCSS(size)};
    ${getTextStyles(fontVariant)};
    border-radius: ${borderRadius};
    background-color: ${speakersPalette[$color][$isActive ? 100 : 50]};
    color: ${speakersPalette[$color][600]};
    transition:
      background-color 0.2s,
      color 0.2s;

    ${$disabled &&
    css`
      background-color: ${theme.palette.grey[$isActive ? 200 : 100]};
      color: ${theme.palette.grey[400]};
    `}
  `;
});
